import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/max-drawdown-calculator',
  component: () => import('../../routes/MaxDrawdownCalculator.svelte'),
  card: {
    id: 'max-drawdown',
    title: 'Maximum Drawdown',
    description: 'Find the largest peak-to-trough decline in your portfolio history and measure downside risk exposure.',
    icon: 'trending_down',
    iconBgClass: 'bg-red-50',
    iconTextClass: 'text-red-600',
    href: '/max-drawdown-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Maximum Drawdown Calculator — Portfolio Risk & Peak-to-Trough Loss',
    description: 'Free Maximum Drawdown calculator identifies the largest percentage decline in portfolio value from peak to trough. Measure downside risk and recovery time.',
  },
};

export default meta;
